import React, { useState, useRef, useEffect } from 'react';
import { api } from './api.js';
import type { InventoryItem } from 'shared/types.js';
import { InventoryItemDetails } from './common.js';

export const InventoryLookup = ({ initialItemCode = '' }: { initialItemCode?: string }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [result, setResult] = useState<InventoryItem | null>(null);
    const [resultSource, setResultSource] = useState<string | null>(null);
    const [notFound, setNotFound] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleLookup = async (value: string) => {
        const lookupValue = value.trim().toUpperCase();
        if (!lookupValue) return;
        setSearchTerm(lookupValue);
        setResult(null);
        setResultSource(null);
        setNotFound(false);
        try {
            const response = await api.post<{ found: boolean, data?: InventoryItem, source?: string }>('/api/inventory/lookup', { searchTerm: lookupValue });
            if (response.found && response.data) {
                setResult(response.data);
                setResultSource(response.source || null);
            } else {
                setNotFound(true);
            }
        } catch (error) {
            setNotFound(true);
        }
    };
    useEffect(() => {
        const itemCode = initialItemCode.trim();
        if (itemCode) {
            handleLookup(itemCode);
        }
    }, [initialItemCode]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.currentTarget.value.toUpperCase());
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleLookup(searchTerm);
            setSearchTerm('');
        }
    };
    return (
        <div className="inventory-lookup-container">
            <div className="inventory-search-bar">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Scan or Enter Item Code"
                    autoFocus
                />
            </div>

            {result && (
                <div className="inventory-result-container flash" key={result.SKU}>
                    {resultSource && <div className="inventory-last-updated">Source: {resultSource === 'pos' ? 'Live POS Data' : resultSource === 'backup' ? 'Backup Database' : resultSource}</div>}
                    <InventoryItemDetails item={result} />
                </div>
            )}
            {notFound && <div className="inventory-not-found">Item <strong>{searchTerm}</strong> not found.</div>}
        </div>
    );
};
